import { render, staticRenderFns } from "./ProjectTabsAddUsers.vue?vue&type=template&id=7cb6bc6c&scoped=true&"
import script from "./ProjectTabsAddUsers.vue?vue&type=script&lang=js&"
export * from "./ProjectTabsAddUsers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTabsAddUsers.vue?vue&type=style&index=0&id=7cb6bc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb6bc6c",
  null
  
)

export default component.exports